export type AppPlatform = "buyer" | "farmer" | "admin";

export const APP_PLATFORM = (process.env.NEXT_PUBLIC_APP_PLATFORM ||
  "buyer") as AppPlatform;

export const platform = {
  isBuyer: APP_PLATFORM === "buyer",
  isFarmer: APP_PLATFORM === "farmer",
  isAdmin: APP_PLATFORM === "admin",
  current: APP_PLATFORM,
} as const;
